import { Component, Input, OnInit, inject } from "@angular/core";
import { Observable } from "rxjs";

import { QueryStringTypesEnum } from "src/app/configs/query-string-types";
import {
  GetEnumValuesDto,
  PaginatedListOfWhiteMessagesWithPaginationDto,
  WhiteMessageByIdDto,
  WhiteMessageStatus,
  WhiteMessagesWithPaginationDto,
} from "src/app/core/api/models";
import { EventTypes } from "src/app/core/constants/event-types";
import { BaseIndexPageComponent } from "src/app/pages/shared/base/components/base-index-page.component";
import { WhiteMessagesService } from "./../../../../core/api/services/white-messages.service";
import { FormPageConfig } from "./../../../../core/models/form-page-config.model";
import { BaseIndexModule } from "src/app/pages/shared/base/modules/base-index.module";
import { WhiteMessageFormComponent } from "../../white-messages/white-message-form/white-message-form.component";
import { OrganizationWhiteMessageFormComponent } from "../../organization-white-messages/organization-white-message-form/organization-white-message-form.component";

@Component({
    selector: "app-base-white-messages-index",
    templateUrl: "./base-white-messages-index.component.html",
    styleUrls: ["./base-white-messages-index.component.scss"],
    imports: [BaseIndexModule, WhiteMessageFormComponent, OrganizationWhiteMessageFormComponent]
})
export class BaseWhiteMessagesIndexComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region properties

  pageName = "whiteMessages";
  /* Binding service endpoints */
  protected currentService = inject(WhiteMessagesService);
  paginationApiMethodName: string = this.currentService.whiteMessagesGetWhiteMessagesWithPagination.name;
  createGetApiMethodName: string = this.currentService.whiteMessagesCreateGet.name;
  auditApiMethodName: string = this.currentService.whiteMessagesGetWhiteMessagesAudit.name;
  /* Binding service endpoints */
  modelWithPagination$: Observable<PaginatedListOfWhiteMessagesWithPaginationDto>;
  items$: Observable<Array<WhiteMessagesWithPaginationDto>>;
  formPageConfig: FormPageConfig<WhiteMessageByIdDto> = {};

  @Input("getTableDataApiMethodName") getTableDataApiMethodName: string;
  @Input("pageTitle") pageTitle: string;
  @Input("isShowOperationBtns") isShowOperationBtns: boolean = true;
  @Input("pageTagName") pageTagName: string;

  WhiteMessageStatusEnumValues: GetEnumValuesDto[] = [];
  PhonebookTypesEnumValues: GetEnumValuesDto[] = [];
  get WhiteMessageStatus() {
    return WhiteMessageStatus;
  }

  isShowOrganizationWhiteMessage: boolean;
  organizationWhiteMessageFormPageConfig: FormPageConfig<WhiteMessageByIdDto> =
    {};

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.title = this.pageTitle;
      this.organizationWhiteMessageFormPageConfig.vocabs =
        this.pageVocabs + "form.";

      // this.pageConfig.showAuditBtn = false;

      if (this.pageTagName)
        this.pageConfig.tableConfig.pageTagName = this.pageTagName;

      if (this.isShowOperationBtns) this.pageConfig.showAddBtn = false;
      else this.pageConfig.showAuditBtn = false;

      this.pageConfig.isAddBtnWithLoading = false;

      // this.onUpdate(2);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  setPageAfterEnterUrl() {
    super.setPageAfterEnterUrl();
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      switch (key) {
        case QueryStringTypesEnum.Update_key:
          this.onUpdateOrganizationWhiteMessage(value, false);
          break;
      }
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi("WhiteMessageStatus").subscribe(
      (values) => (this.WhiteMessageStatusEnumValues = values)
    );
    this.getEnumValuesApi("PhonebookTypes").subscribe(
      (values) => (this.PhonebookTypesEnumValues = values)
    );
  }

  configTableColumns(): void {
    this.tableColumns = [
      {
        title: this.localizer.id,
        name: "id",
        hasSearch: true,
        type: "number",
        noNumberSeparator: true,
      },
      {
        title: this.localizer.number,
        name: "privateNumber",
        hasSearch: true,
        dir: "ltr",
      },
      { title: this.localizer.userName, name: "userName", hasSearch: true },
      {
        title: `${this.tableVocabs}enterSms`,
        name: "enterSms",
        hasSearch: true,
      },
      { title: `${this.tableVocabs}exitSms`, name: "exitSms", hasSearch: true },
      {
        title: `${this.tableVocabs}returnText`,
        name: "returnText",
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}cancelText`,
        name: "cancelText",
        hasSearch: true,
      },
      {
        title: this.localizer.status,
        name: "status",
        hasSearch: true,
        type: "enum",
        enumName: "WhiteMessageStatus",
      },
      {
        title: this.localizer.createDate,
        name: "created",
        hasSearch: true,
        type: "dateTime",
      },
    ];
  }

  ///#region api

  //Get ById
  baseGetByIdApi(id: number): void {
    // this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .whiteMessagesUpdateWhiteMessageStatusGet({ id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  whiteMessagesUpdateWhiteMessageGetApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .whiteMessagesUpdateWhiteMessageGet({ id: id })
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        this.organizationWhiteMessageFormPageConfig.editData = res?.data;
        this.isShowOrganizationWhiteMessage = true;
      });
  }

  //#endregion

  //#region Organization White Message

  onUpdateOrganizationWhiteMessage(id, setUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          "?" +
          QueryStringTypesEnum.Update_key +
          "=" +
          id
      );
    }
    try {
      this.organizationWhiteMessageFormPageConfig.editData = {};
      this.organizationWhiteMessageFormPageConfig.isEditMode = true;
      this.organizationWhiteMessageFormPageConfig.editId = id;
      this.whiteMessagesUpdateWhiteMessageGetApi(id);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  getOrganizationWhiteMessageFormResponse(isSuccess) {
    try {
      if (isSuccess) this.getTableData();

      this.isShowOrganizationWhiteMessage = false;
      this.unSubs();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  //#endregion

  onCreate() {
    try {
      this.currentService[this.createGetApiMethodName]()
        .pipe(this.basePipeOperators())
        .subscribe(
          (res) => {
            if (res) {
              this.isShowOrganizationWhiteMessage = true;
              this.setParentQueryString();
              this.location.go(
                window.location.pathname + "?key-formType=create"
              );
            }
          },
          (error) => {
            this.pageConfig.isVisibleForm = undefined;
            const timeout = setTimeout(() => {
              this.pageConfig.isVisibleForm = false;
              clearTimeout(timeout);
            }, 10);
          }
        );
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }
}
